const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/advogado-hopi-hari"],
    exact: true,
    component: "HopiHari",
  },
];

export default routes;
